import api from 'config/axios';

import AppService from 'common/app-service';
import { ILead, CreateLeadPayload, LeadUpdatePayload } from 'common/lead.interface';

export default class LeadService extends AppService {
  constructor() {
    super('leads', api);
  }

  async all(params: Partial<ILead> = {}): Promise<ILead[]> {
    const response = await this.api.get(this.root(), { params });

    return response.data;
  }

  async create(payload: CreateLeadPayload): Promise<Partial<ILead>> {
    const settledParams = Object.entries(payload).reduce(
      (acc, [key, value]) => (value ? { ...acc, [key]: value } : acc),
      {} as CreateLeadPayload
    );
    const response = await this.api.post(this.root(), settledParams, { params: { isPublicRequest: true } });

    return response.data;
  }

  async update(id: number, payload: LeadUpdatePayload): Promise<Partial<ILead>> {
    const settledParams = Object.entries(payload).reduce(
      (acc, [key, value]) => (value ? { ...acc, [key]: value } : acc),
      {} as LeadUpdatePayload
    );
    const response = await this.api.put(this.root(id), settledParams, { params: { isPublicRequest: true } });

    return response.data;
  }
}
